const STUDENT_TAG = "0";
const TEACHER_TAG = "1";

export const STUDENT_LOGIN_PATH = "/login";
export const TEACHER_LOGIN_PATH = "/teacher/login";
export const STUDENT_HOME_PATH = "/studentHome/lessonList";
export const TEACHER_HOME_PATH = "/teacherHome/lessonList";
export const ADMIN_HOME_PATH = "/adminHome/dashboard";

const WHITE_LIST = [
  STUDENT_LOGIN_PATH,
  TEACHER_LOGIN_PATH,
  "/teacher/regist",
  "/mooc/regist"
];

export function getUserTag() {
  return sessionStorage.getItem("tag");
}

export function hasLogin() {
  return !!(sessionStorage.getItem("userId") && sessionStorage.getItem("token"));
}

export function getUserRole(
  tag = getUserTag(),
  teacherRole = sessionStorage.getItem("teacherRole")
) {
  if (String(tag) === TEACHER_TAG) {
    if (String(teacherRole) === "0") {
      return "super_admin";
    }
    return "teacher";
  }
  if (String(tag) === STUDENT_TAG) {
    return "student";
  }
  return "";
}

export function setHomePath(path) {
  if (path) {
    sessionStorage.setItem("homePath", path);
  }
}

export function getRoleHomePath(tag = getUserTag()) {
  if (getUserRole(tag) === "super_admin") {
    return ADMIN_HOME_PATH;
  }
  if (String(tag) === TEACHER_TAG) {
    return TEACHER_HOME_PATH;
  }
  if (String(tag) === STUDENT_TAG) {
    return STUDENT_HOME_PATH;
  }
  return STUDENT_LOGIN_PATH;
}

export function getDefaultHomePath(tag = getUserTag()) {
  const role = getUserRole(tag);
  const roleHomePath = getRoleHomePath(tag);
  const homePath = sessionStorage.getItem("homePath");
  // homePath 只用于保存各角色的固定首页。不要把历史页面或重定向路由
  // 用作鉴权失败后的回退目标，否则旧会话可能在两个角色路由间循环跳转。
  if (homePath === roleHomePath) {
    const requiredRole = getRequiredRole(homePath);
    if (requiredRole && requiredRole === role) {
      return homePath;
    }
  }
  return roleHomePath;
}

export function getLoginPathByTag(tag = getUserTag()) {
  return String(tag) === TEACHER_TAG ? TEACHER_LOGIN_PATH : STUDENT_LOGIN_PATH;
}

export function getLoginPathByPath(path = "") {
  return path.indexOf("/teacher") === 0 ||
    path.indexOf("/teacherHome") === 0 ||
    path.indexOf("/adminHome") === 0
    ? TEACHER_LOGIN_PATH
    : STUDENT_LOGIN_PATH;
}

export function isRouteWhiteListed(path = "") {
  return WHITE_LIST.indexOf(path) > -1;
}

export function getRequiredRole(path = "") {
  if (path.indexOf("/adminHome") === 0) {
    return "super_admin";
  }
  if (path.indexOf("/teacherHome") === 0 || path.indexOf("/teacher/question-preview") === 0) {
    return "teacher";
  }
  if (path.indexOf("/studentHome") === 0) {
    return "student";
  }
  return "";
}

export function getFallbackPath(path = "") {
  if (hasLogin()) {
    return getDefaultHomePath();
  }
  return getLoginPathByPath(path);
}

export function clearAuthState() {
  sessionStorage.clear();
}

export function resetRouter(router) {
  // 当前项目使用静态路由；这里预留给后续动态权限路由重置。
  return router;
}

export function logout(router, tag = getUserTag()) {
  const loginPath = getLoginPathByTag(tag);
  clearAuthState();
  resetRouter(router);
  if (router) {
    return router.replace(loginPath);
  }
  return Promise.resolve();
}



// WEBPACK FOOTER //
// ./src/common/auth.js